<template>
    <form-partition :title="title" ref="info" :model="info">
        <div style="height: 50px; line-height: 50px">
            <span style="margin-right: 25px">{{ text }}</span>
            <!-- 退租方式 -->
            <check-tag-group
                v-if="isSurrender"
                style="display: inline-block"
                v-model="info.cancelRentType"
                color="primary"
                unpopulated
                @on-change="onCancelRentTypeChange"
            >
                <check-tag
                    v-for="item in cancelRentTypeList"
                    :key="item.id"
                    :name="item.id"
                    style="margin-right: 10px"
                    >{{ item.text }}</check-tag
                >
            </check-tag-group>
            <!-- 实际退租/换房日期 -->
            <DatePicker
                v-if="showDatePicker"
                v-model="info.date"
                transfer
                type="date"
                style="width: 160px"
                :clearable="false"
                :options="options"
                @on-change="onDateChange"
            />
            <!-- 换房押金处理方式 -->
            <check-tag-group
                v-if="!isSurrender"
                style="display: inline-block"
                v-model="info.depositHandleType"
                color="primary"
                unpopulated
                @on-change="onDepositHandleTypeChange"
            >
                <check-tag
                    v-for="item in dict.depositHandleType.toList()"
                    :key="item.id"
                    :name="item.id"
                    style="margin-left: 10px"
                >
                    {{ item.text }}
                </check-tag>
            </check-tag-group>
            <span v-if="isDiscount" style="margin-left: 25px">
                <span style="color: red">注：</span>
                当前费用清算含优惠，请注意核对
            </span>
        </div>
        <!-- 清算列表 -->
        <Table
            ref="mt"
            :columns="columns"
            :data="info.list"
            :loading="loading"
            height="350"
            editMode="grid"
        >
            <template v-slot:feeType="{ row }">
                {{ dict.feeType.val(row.feeType) }} :
                <span v-if="row.updateAmount" style="color: red">
                    {{
                        row.isReceive === '1'
                            ? row.receivables
                            : row.refund | currency
                    }}
                </span>
                <span v-else>
                    {{
                        row.isReceive === '1'
                            ? row.receivables
                            : row.refund | currency
                    }}
                </span>
                <!-- 定金抵扣项 -->
                <div v-if="row.resAmountText" style="color: red">
                    {{ row.resAmountText }}
                </div>
            </template>
            <template v-slot:startDate="{ row }">
                {{ row.startDate ? `${row.startDate} 至 ${row.endDate}` : '' }}
            </template>
            <template v-slot:receivables="{ row, column }">
                <div class="flex">
                    <Radio
                        :disabled="canFeeUpdate(row) === false"
                        v-model="row.isReceive"
                        true-value="1"
                        false-value="2"
                        @on-change="expenseChange"
                    />
                    <cell-input-number
                        :row="row"
                        :column="column"
                        :cellEditing="
                            row.isReceive === '1' && canFeeUpdate(row)
                        "
                        field="receivables"
                        @on-change="expenseChange"
                    ></cell-input-number>
                </div>
            </template>
            <template v-slot:refund="{ row, column }">
                <div class="flex">
                    <Radio
                        v-model="row.isReceive"
                        :disabled="canFeeUpdate(row) === false"
                        true-value="2"
                        false-value="1"
                        style="color: rgba(0, 0, 0, 0)"
                        @on-change="expenseChange"
                    />
                    <cell-input-number
                        :row="row"
                        :column="column"
                        :cellEditing="
                            row.isReceive === '2' && canFeeUpdate(row)
                        "
                        field="refund"
                        @on-change="expenseChange"
                    ></cell-input-number>
                </div>
            </template>
            <!-- 操作 -->
            <template v-slot:action="{ row }">
                <Icon
                    v-if="canFeeDel(row)"
                    type="ios-remove-circle-outline"
                    size="20"
                    @click="desc(row)"
                />
            </template>
        </Table>
        <div class="chooseFeeType">
            <Select
                v-if="$can('feeAdd')"
                v-model="addFee"
                transfer
                style="width: 160px"
                placeholder="请添加费用"
                clearable
                @on-change="add"
            >
                <Option
                    v-for="(item, index) in dict.otherFee.options.list"
                    :value="item.id"
                    :key="index"
                    >{{ item.text }}</Option
                >
            </Select>
        </div>
        <div class="totalPrice">清算统计：{{ totalPrice | currency }}元</div>
        <!-- 是否抵租金 -->
        <FormItem
            v-show="canDeductionByLast"
            class="contract-content-class"
            style="margin-top: 16px"
            :labelWidth="220"
        >
            <template #label>
                <div style="text-align: left">
                    清算待付款，是否直接抵做新房的费用
                </div>
            </template>
            <i-switch
                v-model="info.isDeductionByLast"
                :true-value="'1'"
                :false-value="'0'"
            />
        </FormItem>
    </form-partition>
</template>

<script>
import { mapCell, editCell } from '_c/grid/renderCell'
import { ymd, round, toDateYmd } from '_u/helper'
import dayjs from 'dayjs'
import { CellInputNumber } from 'ivux'

export default {
    name: 'ExpenseSettlement',
    props: {
        value: {
            type: Object,
            default: () => ({
                list: [],
                date: '',
                depositHandleType: ['1'],
                isDeductionByLast: '1',
            }),
        },
        discount: {
            type: Array,
            default: () => [],
        },
        startDate: {
            type: String,
            default: '',
        },
        endDate: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '费用清算',
        },
        text: {
            type: String,
            default: '换房时间',
        },
        // 退房/换房
        type: {
            type: String,
            default: '',
        },
        // 是否显示CheckTag
        isSurrender: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        // 退租类型
        cancelRentType: {
            type: [String, Number],
            default: '',
        },
        // 租金是否全部交纳
        isAllRentPaid: {
            type: Boolean,
            default: false,
        },
    },
    components: { CellInputNumber },
    data() {
        var contractEndTime = dayjs(toDateYmd(this.endDate))
                .startOf('date')
                .valueOf(),
            today = dayjs().startOf('date').valueOf()

        return {
            info: this.value,
            dict: {
                feeType: this.$dict.NULL,
                otherFee: this.$dict.NULL,
                billStatus: this.$dict.NULL,
                depositHandleType: this.$dict.NULL,
                cancelRentType: this.$dict.NULL,
            },
            addFee: '',
            options: {
                disabledDate: (date) => {
                    // 逾期退房
                    if (
                        this.isSurrender &&
                        this.info.cancelRentType.indexOf('3') >= 0
                    ) {
                        return date.getTime() < today
                    } else {
                        return !(
                            date.getTime() >= today &&
                            date.getTime() < contractEndTime
                        )
                    }
                },
            },
            totalPrice: 0,
        }
    },
    computed: {
        columns() {
            return [
                {
                    key: 'feeType',
                    title: '费用名称',
                    align: 'left',
                    minWidth: 130,
                    slot: 'feeType',
                },
                {
                    key: 'startDate',
                    title: '费用期限',
                    align: 'left',
                    minWidth: 200,
                    slot: 'startDate',
                },
                {
                    key: 'billStatus',
                    title: '状态',
                    align: 'left',
                    minWidth: 80,
                    render: mapCell(this.dict.billStatus.toList()),
                },
                {
                    key: 'receivables',
                    title: '收款(元)',
                    align: 'left',
                    minWidth: 100,
                    slot: 'receivables',
                },
                {
                    key: 'refund',
                    title: '退款(元)',
                    align: 'left',
                    minWidth: 120,
                    slot: 'refund',
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 100,
                    slot: 'action',
                    // fixed: "right",
                },
            ]
        },
        showDatePicker() {
            let isShow = true
            if (this.type === '3') {
                if (this.info.cancelRentType[0] === '1') {
                    isShow = false
                }
            }
            return isShow
        },
        isDiscount() {
            if (this.isSurrender && this.info.cancelRentType[0] === '1') {
                return false
            }

            if (!this.discount || this.discount.length == 0) {
                return false
            }

            let flag = false
            this.discount.forEach((v) => {
                let startDate,
                    endDate = ''
                // 按金额、天数优惠
                if (v.startDate && v.endDate) {
                    startDate = v.startDate
                    endDate = v.endDate
                }

                // 按合同月优惠
                if (v.monthText) {
                    let monthText = v.monthText.substring(
                        v.monthText.indexOf('(') + 1,
                        v.monthText.lastIndexOf(')')
                    )
                    let split = monthText.split(' 至 ')
                    startDate = split[0]
                    endDate = split[1]
                }

                if (!startDate || !endDate) {
                    return
                }

                this.info.list.forEach((b) => {
                    // 押金、违约金不做处理
                    if (b.feeType === '2' || b.feeType === '15') {
                        return
                    }

                    if (
                        (toDateYmd(b.startDate) <= toDateYmd(startDate) &&
                            toDateYmd(b.endDate) >= toDateYmd(startDate)) ||
                        (toDateYmd(b.startDate) <= toDateYmd(endDate) &&
                            toDateYmd(b.endDate) >= toDateYmd(endDate))
                    ) {
                        flag = true
                    }
                })
            })
            return flag
        },
        cancelRentTypeList() {
            var list = this.dict.cancelRentType.toList()
            // 逾期退租
            if (this.cancelRentType == '3') {
                return list.filter((v) => v.id == '3')
            }
            // 到期退租/违约退租
            else if (this.isAllRentPaid) {
                return list.filter((v) => v.id != '3')
            }
            // 违约退租
            else {
                return list.filter((v) => v.id == '2')
            }
        },
        canDeductionByLast() {
            return this.isSurrender === false && this.totalPrice < 0
        },
    },
    watch: {
        'info.isDeductionByLast'(val) {
            this.$emit('on-bill-change')
        },
    },
    created() {
        this.$dict
            .get([
                'fee_type',
                'other_fee',
                'bill_status',
                'deposit_handle_type',
                'cancel_rent_type',
            ])
            .then((group) => {
                Object.assign(this.dict, group)
            })
        // 清算统计
        this.$watch(
            function () {
                return this.info.list.reduce((acc, v) => {
                    if (v.isReceive === '1') {
                        acc += v.receivables - 0
                    } else if (v.isReceive === '2') {
                        acc -= v.refund - 0
                    }
                    return acc
                }, 0)
            },
            function (val) {
                this.totalPrice = round(val, 2)
                // 抵租金默认值
                if (val > 0) {
                    this.info.isDeductionByLast = '0'
                }
            },
            {
                immediate: true,
            }
        )
    },
    methods: {
        // 删除费用类型
        desc(row) {
            const index = this.info.list.findIndex((v) => v.id === row.id)
            this.info.list.splice(index, 1)
        },
        // 增加费用类型
        add(val) {
            console.log(val)
            if (!val) {
                return
            }
            const list = this.info.list
            list.push({
                amount: 0,
                billStatus: '1',
                endDate: '',
                feeType: val,
                isReceive: '1',
                planAmount: 0,
                planDate: '',
                receivables: 0,
                refund: 0,
                startDate: '',
                resAmountText: '',
            })
        },
        // 能否修改费用
        canFeeUpdate(row) {
            var id = row.id || ''
            return this.$can('feeUpdate') || id.startsWith('_')
        },
        // 能否删除费用
        canFeeDel(row) {
            var id = row.id || ''
            return this.$can('feeDel') || id.startsWith('_')
        },
        onCancelRentTypeChange() {
            this.$emit('on-condition-change')
        },
        onDateChange() {
            this.$emit('on-bill-change')
            this.$emit('on-condition-change')
        },
        onDepositHandleTypeChange() {
            this.$emit('on-bill-change')
            this.$emit('on-condition-change')
        },
        // 账单数据发生改变
        expenseChange() {
            this.$emit('on-change')
            // 新房抵扣模式，改变清算数据会影响账单生成结果
            if (this.info.isDeductionByLast == '1') {
                this.$emit('on-bill-change')
            }
        },
    },
}
</script>

<style lang="less" scoped>
.chooseFeeType {
    background: #fff;
    text-align: center;
    line-height: 50px;
    border: 1px solid #dcdee2;
    border-top: none;
}
.totalPrice {
    font-size: 16px;
    text-align: left;
    color: #333333;
    margin-top: 23px;
}
</style>
